import { styled } from '@mui/material/styles';

import { Box } from '@/shared/ui';

export const StyledSettingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  border: `1px solid ${theme.palette.custom.grey6}`,
  borderRadius: '20px',
  backgroundColor: theme.palette.common.white,
  paddingTop: '16px',
  paddingBottom: '16px',
  marginRight: '79px',
  marginBottom: '41px',
}));
